// extracted by mini-css-extract-plugin
export var footerSocialItem = "social-medias-module--footer-social-item--d089a";
export var footerSocialLinks = "social-medias-module--footer-social-links--1e03b";